/* eslint-disable sonarjs/no-duplicate-string */

export const promotionType = [
  { value: 'Rafaksi', label: 'Rafaksi' },
  { value: 'Rafaksi PWP', label: 'Rafaksi PWP' },
  { value: 'Rafaksi BMSM v2', label: 'Rafaksi BMSM' },
  { value: 'Rafaksi Voucher', label: 'Rafaksi Voucher' },
  { value: 'Freebies', label: 'Freebies' },
  { value: 'Product Bonus', label: 'Product Bonus' },
  { value: 'Direct Discount', label: 'Direct Discount' },
  { value: 'Ads Revenue', label: 'Ads Revenue' },
  { value: 'Rafaksi Flexi Combo', label: 'Rafaksi Flexi Combo' },
  { value: 'Flash Sale', label: 'Flash Sale' },
]

export const promotionTypeFilter = [
  ...promotionType?.filter((type) => type.value !== 'Rafaksi BMSM v2'),
  { value: 'Rafaksi BMSM', label: 'Rafaksi BMSM (old)' },
  { value: 'Rafaksi BMSM v2', label: 'Rafaksi BMSM' },
]

export const actualClaimStatus = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Already Uploaded' },
  { value: 'false', label: 'Not Yet Uploaded' },
]

export const approvedClaimStatus = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Already Approved' },
  { value: 'false', label: 'Not Yet Approved' },
]

export const downloadStatus = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Already Dowloaded' },
  { value: 'false', label: 'Not Yet Downloaded' },
]

export const skpStatus = ['', 'Draft', 'Pending Approval', 'Rejected', 'Approved', 'Archived']

export const internalPromotionType = [
  { value: 'Internal Campaign', label: 'Internal Campaign' },
  { value: 'Internal Voucher', label: 'Internal Voucher' },
  { value: 'Internal BMSM v2', label: 'Internal BMSM' },
  { value: 'Internal PWP', label: 'Internal PWP' },
  { value: 'Internal Campaign Segmentation', label: 'Internal Campaign Segmentation' },
  { value: 'Internal Rafaksi Flexi Combo', label: 'Internal Rafaksi Flexi Combo' },
]

export const internalPromotionTypeFilter = [
  ...internalPromotionType.filter((type) => type.value !== 'Internal BMSM v2'),
  { value: 'Internal BMSM', label: 'Internal BMSM (old)' },
  { value: 'Internal BMSM v2', label: 'Internal BMSM' },
]

export const syaratKetentuanPromotionType = [...promotionType, ...internalPromotionType]

export const budgetType = [
  'AG - Astro Goods',
  'AB - Astro Basic',
  'Retail',
  'Fresh',
  'AK - Astro Kitchen',
  'Ads Revenue',
  'Flush Out',
]
